import { Injectable } from '@angular/core';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { Store } from '@ngrx/store';
import { selectDoShowLoader } from '@selectors/app.selector';
import { selectLoaderTimeout } from '@selectors/cms.selector';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { BehaviorSubject, combineLatest, filter, Subject, switchMap, take, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UtilitiesService {
  documentClickedTarget: Subject<HTMLElement> = new Subject<HTMLElement>();
  private selectedTripIndexUpdate$ = new Subject<void>();
  private flightsSearchInProgress$ = new BehaviorSubject<boolean>(false);

  private flightSearchInProgressTimeout$ = this.store.select(selectLoaderTimeout)
  private doShowLoader$ = this.store.select(selectDoShowLoader);

  constructor(private store: Store, private growthBookService: GrowthBookService) {}

  public onSelectedTripIndexUpdate$() {
    return this.selectedTripIndexUpdate$.asObservable();
  }

  public updateSelectedTripIndex() {
    this.selectedTripIndexUpdate$.next();
  }

  public onFlightsSearchInProgress$() {
    return this.flightsSearchInProgress$.asObservable();
  }

  public updateFlightSearchActionStarted() {
    if (this.growthBookService.growthBook.isOn(GrowthBookFeatureKeys.FEAT_US735_INTERSTITIAL_LOADING_SCREEN) && this.growthBookService.growthBook.getFeatureValue(GrowthBookFeatureKeys.FEAT_US735_INTERSTITIAL_LOADING_SCREEN, '') !== 'a') {
      this.flightsSearchInProgress$.next(true);
        combineLatest([this.flightSearchInProgressTimeout$, this.doShowLoader$])
        .pipe(
          filter(([timeout, loaderVisible]) => !!timeout && loaderVisible),
          take(1),
          switchMap(([timeout, _]) => timer(timeout))
        )
        .subscribe(() => {
          this.flightsSearchInProgress$.next(false);
        })
    }
  }

  public updateFlightSearchActionAborted() {
    this.flightsSearchInProgress$.next(false);
  }
}
